import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger
} from 'shared/components/ui/dropdown-menu';
import {
    Button
} from 'shared/components/ui/button';
import {
    Layout, Code2, ChevronDown
} from 'lucide-react';
import {
 JSX
} from 'react';

interface HeaderProps {
    activeBuilder: 'opcode' | 'page';
    setActiveBuilder: (builder: 'opcode' | 'page') => void;
}

export default function Header({
    activeBuilder, setActiveBuilder
}: HeaderProps): JSX.Element {
    return (
        <div className="flex border-b">
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button variant="ghost" className="flex-1 justify-between">
                        {activeBuilder === 'opcode' ? 'OpCode Builder' : 'Page Builder'}
                        <ChevronDown className="h-4 w-4 ml-2" />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-56">
                    <DropdownMenuItem onClick={() => setActiveBuilder('opcode')}>
                        <Code2 className="h-4 w-4 mr-2" />
                        OpCode Builder
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => setActiveBuilder('page')}>
                        <Layout className="h-4 w-4 mr-2" />
                        Page Builder
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}